var Student = "学生";
var jobRole = {
	"Job role": "工作职务",
	"Academic / Researcher": "学术/研究员",
	"Advisor / Consultant": "顾问/咨询师",
	"Business Executive": "商业主管",
	"Developer / Engineer": "开发人员/工程师",
	"Entrepreneur (Founder/Co-Founder)": "企业家（创始人/联合创始人）",
	"IT Executive": "IT 主管",
	"IT Professional or Technical Manager": "IT 专业人员或技术经理",
	"Press / Media Analyst": "新闻/媒体分析师",
	"Sales / Marketing": "销售/营销",
	Student: Student,
	"Solution or Systems Architect": "解决方案或系统架构师",
	"System Administrator": "系统管理员",
	"Venture Capitalist": "风险投资人"
};

export { Student, jobRole as default };
